import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../utils/authProvider";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Dropdown,
  Form,
  Tab,
  Tabs,
  Spinner,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import TopNav from "../components/navbars/Top_NavBar/topNav";
import SideStackedBarChart from "../components/DownTime/stackedBarChart";
import DownTimeLostOilAndGas from "../components/DownTime/downTimeLostOilGasChart";
// import sampleDownTimeData from "../components/DownTime/sampleDownTimeData";
import DownTimeGroupContainer from "../components/DownTime/downTimeGroups";
import DownTimeSiteListTree from "../components/DownTime/downTimeSiteListTree";
import DownTimePieChartPercent from "../components/DownTime/downTimePieChartPercent";
import DownTimeMRT from "../components/DownTime/downTimeMonhltyReportTable";

const DownTime = () => {
  const navigate = useNavigate();
  const dayjs = require("dayjs");
  const { getAuth, refreshCheck } = useAuthContext();
  const [downTimeData, setDownTimeData] = useState();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const [showTotalDowntimeModal, setShowTotalDowntimeModal] = useState(false);
  const [showLostProductionModal, setShowLostProductionModal] = useState(false);
  const [showDowntimeByCodeModal, setShowDowntimeByCodeModal] = useState(false);

  const [groupName, setGroupName] = useState("Select a Group");
  const [lastKnownGroupID, setLastKnownGroupID] = useState(
    localStorage.getItem("LastGroupID_DownTime")
  );
  const [lastKnownGroupName, setLastKnownGroupName] = useState(
    localStorage.getItem("LastGroupName_DownTime")
  );
  const [siteArray, setSiteArray] = useState([]);
  const [lastKnownSiteArray, setLastKnownSiteArray] = useState([]);
  const [treeReload, setTreeReload] = useState(false);
  const [userRefOrSiteName, setUserRefOrSiteName] = useState("UR");

  const [activeTab, setActiveTab] = useState("Total_Downtime");

  const [daysBack, setDaysBack] = useState(30);
  const [thisDay, setThisDay] = useState(dayjs().format("YYYY-MM-DD"));
  const [fromDate, setFromDate] = useState(
    dayjs().subtract(30, "day").format("YYYY-MM-DD")
  );

  const [noDownTimeAlert, setNoDownTimeAlert] = useState(false);
  useEffect(() => {
    if (noDownTimeAlert === true) {
      setTimeout(() => {
        setNoDownTimeAlert(false);
      }, 5000);
    }
  }, [noDownTimeAlert]);
  useEffect(() => {
    const storedGroupID = localStorage.getItem("LastGroupID_DownTime");
    const storedGroupName = localStorage.getItem("LastGroupName_DownTime");
    if (storedGroupID && storedGroupID !== "0") {
      setLastKnownGroupID(storedGroupID);
    }
    if (storedGroupName && storedGroupName !== "Select a Group") {
      setGroupName(storedGroupName);
    }
  }, []);
  useEffect(() => {
    if (!downTimeData || downTimeData.length === 0) {
      // console.log("No downtime data available");
      return;
    }
    setDataLoaded(true);
  }, [downTimeData]);
  useEffect(() => {
    setTreeReload(true);
  }, [userRefOrSiteName]);
  useEffect(() => {
    if (!siteArray || siteArray.length === 0) {
      // console.log("No site array available");
      return;
    } else if (siteArray.length > 0) {
      console.log("siteArray in downtime stage", siteArray);
      setLastKnownSiteArray(siteArray);
      getDownTimeData(siteArray);
    }
  }, [siteArray]);
  useEffect(() => {
    if (daysBack == 30) {
      const day30 = dayjs().subtract(30, "day").format("YYYY-MM-DD");
      updateFromDate(day30);
    } else if (daysBack == 60) {
      const day60 = dayjs().subtract(60, "day").format("YYYY-MM-DD");
      updateFromDate(day60);
    } else if (daysBack == 90) {
      const day90 = dayjs().subtract(90, "day").format("YYYY-MM-DD");
      updateFromDate(day90);
    } else if (daysBack == "1Yr") {
      const day356 = dayjs().subtract(365, "day").format("YYYY-MM-DD");
      updateFromDate(day356);
    } else if (daysBack == "2Yr") {
      const day730 = dayjs().subtract(730, "day").format("YYYY-MM-DD");
      updateFromDate(day730);
    } else if (daysBack == "3Yr") {
      const day1095 = dayjs().subtract(1095, "day").format("YYYY-MM-DD");
      updateFromDate(day1095);
    } else if (daysBack == "All") {
      const day10000 = dayjs().subtract(10000, "day").format("YYYY-MM-DD");
      updateFromDate(day10000);
    }
  }, [daysBack]);
  useEffect(() => {
    if (siteArray.length > 0) {
      getDownTimeData(siteArray);
    }
  }, [fromDate]);
  const updateFromDate = (date) => {
    setFromDate(date);
  };
  const CenteredTotalDowntimeModal = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Total Downtime Hours by Well
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dataLoaded === true ? (
            <SideStackedBarChart
              downTimeData={downTimeData}
              active={activeTab === "Total_Downtime"}
            />
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
    );
  };
  const CenteredLostProductionModal = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Total Downtime Hours by Well
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dataLoaded === true && downTimeData.length > 0 ? (
            <DownTimeLostOilAndGas
              downTimeData={downTimeData}
              active={activeTab === "Lost_Production"}
            />
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
    );
  };
  const CenteredDowntimeByCodeModal = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Total Downtime Hours by Well
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dataLoaded === true && downTimeData.length > 0 ? (
            <DownTimePieChartPercent
              downTimeData={downTimeData}
              active={activeTab === "Downtime_by_code"}
            />
          ) : (
            <></>
          )}
        </Modal.Body>
      </Modal>
    );
  };
  const updateStageGroupName = (groupName) => {
    localStorage.setItem("LastGroupName_DownTime", groupName);
    setGroupName(groupName);
  };
  const updateLastKnownGroupID = (gid) => {
    if (gid === "0") {
      return;
    } else {
      localStorage.setItem("LastGroupID_DownTime", gid);
      setLastKnownGroupID(gid);
      setLastKnownGroupName(groupName);
    }
  };
  const handleUserRefOrSiteName = (e) => {
    setTreeReload(false);
    setUserRefOrSiteName(e.target.value);
  };
  const handleDaysBack = (event) => {
    event.preventDefault();
    // console.log("the value is", event.target.dataset.value);
    setDaysBack(event.target.dataset.value);
  };
  const filterDownTimeData = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.log("No downtime data available to filter");
      return;
    }
    const filtered = data.filter((item) => item.downCode != null);
    if (filtered.length === 0) {
      console.log("No valid downtime data found after filtering");
      setNoDownTimeAlert(true);
      return;
    } else {
      const mapData = filtered.map((item) => {
        const hourlyOil = item.average7Oil / 24;
        const hourlyGas = item.average7Gas / 24;
        const lostOil = item.hoursDown * hourlyOil;
        const lostGas = item.hoursDown * hourlyGas;

        return {
          siteName: item.siteName,
          date: item.date,
          hoursDown: item.hoursDown.toFixed(2),
          downCode: item.downCode,
          downcodeDescription: item.downcodeDescription,
          remarks: item.remarks,
          grossOil: item.grossOil,
          grossGas: item.grossGas,
          grossWater: item.grossWater,
          average7Oil: item.average7Oil,
          average7Gas: item.average7Gas,
          lostOil: parseFloat(lostOil.toFixed(2)),
          lostGas: parseFloat(lostGas.toFixed(2)),
        };
      });
      console.log("mapData", mapData);
      setDownTimeData(mapData);
    }
  };
  const getDownTimeData = async (siteArray) => {
    console.log("running");
    const authT = getAuth();
    if (authT) {
      setDataLoading(true);
      setDataLoaded(false);
      setDownTimeData([]);
      const siteArrayData = {
        siteIds: siteArray,
        from: fromDate,
        to: thisDay,
      };
      console.log("siteArrayData", siteArrayData);
      const options = {
        method: "POST",
        url: "https://api.pramsplus.com/daily-site",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authT}`,
        },
        data: siteArrayData,
      };
      console.log("options", options);
      try {
        const res = await axios.request(options);
        filterDownTimeData(res.data.items);
        console.log("res.data.items in call", res.data.items);
        setDataLoading(false);
        return;
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("DownTime Data Fetch");
          if (valid === true) {
            console.log("Retrying DownTime Data Fetch api call");
            getDownTimeData(siteArray);
          } else if (valid === false) {
            console.log("all retries failed DownTime Data Fetch");
            navigate("/login");
          }
        } else {
          console.log(
            "Redirecting to login something went wrong in DownTime Data Fetch"
          );
          navigate("/login");
        }
        return;
      }
    }
  };
  const renderSiteTree = (props) => {
    console.log("RST lastKnownGroupID", lastKnownGroupID);
    console.log("RST lastKnownGroupName", lastKnownGroupName);
    if (lastKnownGroupID) {
      return (
        <DownTimeSiteListTree
          userRefOrSiteName={props}
          getAuth={getAuth}
          refreshCheck={refreshCheck}
          groupID={lastKnownGroupID}
          setSiteArray={setSiteArray}
          setGroupName={setGroupName}
          lastChecked={lastKnownSiteArray}
        />
      );
    } else {
      return <h6 style={{ color: "Black" }}>Waiting on Group Selection...</h6>;
    }
  };
  return (
    <>
      <TopNav />
      <Container fluid style={{ height: "92vh", overflow: "hidden" }}>
        <Row style={{ height: "100%", width: "100%", overflowY: "auto" }}>
          {/* Left Vertical Section */}
          <Col
            md={2}
            className="bg-light"
            style={{ height: "100%", overflow: "hidden" }}
          >
            <Row style={{ paddingTop: "20px" }}>
              <Col>
                <Dropdown>
                  <Dropdown.Toggle
                    // id="dropdown-basic"
                    id="groupSelect"
                    style={{
                      width: "290px",
                    }}
                  >
                    {groupName}
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    style={{
                      width: "300px",
                    }}
                  >
                    <DownTimeGroupContainer
                      updateStageGroupName={updateStageGroupName}
                      updateLastKnownGroupID={updateLastKnownGroupID}
                      getAuth={getAuth}
                      refreshCheck={refreshCheck}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
            <Row>
              <div
                style={{ paddingTop: "15px" }}
                className="btn-group dropdown"
              >
                <button
                  type="button"
                  className="btn btn-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    marginBottom: "2px",
                    width: "142px",
                  }}
                >
                  Days Back - {daysBack}
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-dark"
                  style={{
                    width: "120px",
                  }}
                >
                  <li style={{ textAlign: "center" }}>
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="30"
                    >
                      30 Days
                    </a>
                  </li>
                  <li
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="60"
                    >
                      60 Days
                    </a>
                  </li>
                  <li
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="90"
                    >
                      90 Days
                    </a>
                  </li>
                  <li
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="1Yr"
                    >
                      1 Year
                    </a>
                  </li>
                  <li
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="2Yr"
                    >
                      2 Years
                    </a>
                  </li>
                  <li
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="3Yr"
                    >
                      3 Years
                    </a>
                  </li>
                  <li
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <a
                      className="dropdown-item"
                      onClick={handleDaysBack}
                      data-value="All"
                    >
                      All
                    </a>
                  </li>
                </ul>
              </div>
            </Row>
            {dataLoading === true ? (
              <Row className="text-center">
                <Col>
                  <Spinner animation="border" variant="dark" />
                  <Spinner animation="border" variant="info" />
                  <Spinner animation="border" variant="primary" />
                  <Spinner animation="border" variant="secondary" />
                </Col>
              </Row>
            ) : null}
            <Row>
              <Col>
                <Form.Check
                  type={"radio"}
                  id={`show_UR`}
                  label={`User Ref`}
                  checked={userRefOrSiteName === "UR"}
                  value={"UR"}
                  onChange={handleUserRefOrSiteName}
                />
              </Col>
              <Col>
                <Form.Check
                  type={"radio"}
                  id={`show_SN`}
                  label={`Site Name`}
                  checked={userRefOrSiteName === "SN"}
                  value={"SN"}
                  onChange={handleUserRefOrSiteName}
                />
              </Col>
            </Row>
            <Row
              id="SiteListHolder"
              style={{
                marginLeft: "0px",
                minHeight: "725px",
                maxHeight: "725px",
              }}
            >
              {treeReload === true ? (
                renderSiteTree(userRefOrSiteName)
              ) : (
                <h6 style={{ color: "Black" }}>
                  Waiting on Group Selection...
                </h6>
              )}
            </Row>
          </Col>
          {/* Main Section */}
          <Col
            md={10}
            className="p-4"
            style={{ height: "100%", overflowY: "scroll", overflowX: "hidden" }}
          >
            {dataLoaded === true ? (
              <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                <Tab eventKey="Total_Downtime" title="Total Downtime">
                  <Row>
                    <Col md={12}>
                      <Card className="mb-4">
                        <Card.Body>
                          <Card.Title>Total Downtime Hours by Well</Card.Title>
                          <Card.Text>
                            <Col md={{ span: 2, offset: 11 }}>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => setShowTotalDowntimeModal(true)}
                              >
                                Full screen View
                              </Button>
                            </Col>
                          </Card.Text>
                          <CenteredTotalDowntimeModal
                            show={showTotalDowntimeModal}
                            onHide={() => setShowTotalDowntimeModal(false)}
                          />
                          {dataLoaded === true && downTimeData.length > 0 ? (
                            <SideStackedBarChart
                              downTimeData={downTimeData}
                              active={activeTab === "Total_Downtime"}
                            />
                          ) : (
                            // <SideStackedBarChart
                            //   uniqueSiteNames={sampleDownTimeData}
                            //   active={activeTab === "Total_Downtime"}
                            // />
                            <></>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="Lost_Production" title="Lost Production">
                  <Row>
                    <Col md={12}>
                      <Card className="mb-4">
                        <Card.Body>
                          <Card.Title>Lost Production by Well</Card.Title>
                          <Card.Text>
                            <Col md={{ span: 2, offset: 11 }}>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => setShowLostProductionModal(true)}
                              >
                                Full screen View
                              </Button>
                            </Col>
                          </Card.Text>
                          <CenteredLostProductionModal
                            show={showLostProductionModal}
                            onHide={() => setShowLostProductionModal(false)}
                          />
                          {dataLoaded === true && downTimeData.length > 0 ? (
                            <DownTimeLostOilAndGas
                              downTimeData={downTimeData}
                              active={activeTab === "Lost_Production"}
                            />
                          ) : (
                            <></>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab>
                <Tab eventKey="Downtime_by_code" title="Downtime by Code">
                  <Row>
                    <Col md={12}>
                      <Card className="mb-4">
                        <Card.Body>
                          <Card.Title>Downtime % by Code</Card.Title>
                          <Card.Text>
                            <Col md={{ span: 2, offset: 11 }}>
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => setShowDowntimeByCodeModal(true)}
                              >
                                Full screen View
                              </Button>
                            </Col>
                          </Card.Text>
                          <CenteredDowntimeByCodeModal
                            show={showDowntimeByCodeModal}
                            onHide={() => setShowDowntimeByCodeModal(false)}
                          />
                          {dataLoaded === true && downTimeData.length > 0 ? (
                            <DownTimePieChartPercent
                              downTimeData={downTimeData}
                              active={activeTab === "Downtime_by_code"}
                            />
                          ) : (
                            <></>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab>
                <Tab
                  eventKey="Report_Table"
                  title="Report Table"
                >
                  <Row>
                    <Col md={12}>
                      <Card className="mb-4">
                        <Card.Body>
                          <Card.Title>Downtime Table</Card.Title>
                          {dataLoaded === true && downTimeData.length > 0 ? (
                            <DownTimeMRT
                              downTimeData={downTimeData}
                              active={activeTab === "Report_Table"}
                            />
                          ) : (
                            <></>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </Tab>
              </Tabs>
            ) : (
              <Row>
                <Col md={12}>
                  <Card className="mb-4">
                    <Card.Body>
                      <Card.Title>Waiting on site selection</Card.Title>
                      <Card.Text>
                        Please select a group followed by at least one site.
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}
            {noDownTimeAlert === true ? (
              <Row>
                <Col md={5}>
                  <Alert
                    variant="danger"
                    onClose={() => setNoDownTimeAlert(false)}
                    dismissible
                  >
                    <Alert.Heading>No Downtime Data Available</Alert.Heading>
                    <p>
                      Please try selecting another site or extending the date
                      range.
                    </p>
                  </Alert>
                </Col>
              </Row>
            ) : null}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DownTime;
